import { connect, type NatsConnection } from "nats.ws";

export async function initializeNatsConnection(
	brokerUrl: string
): Promise<NatsConnection | null> {
	try {
		const nc = await connect({
			servers: brokerUrl,
		});
		console.log(`NatsClient:: Connected to ${nc.getServer()}`);
		return nc;
	} catch (error) {
		console.error(`NatsClient:: Connection failed: ${error}`);
		return null;
	}
}

export function publishNatsMessage(
	nc: NatsConnection,
	topic: string,
	protoBinary: Uint8Array
): void {
	nc.publish(topic, protoBinary);
	console.log(`NatsClient:: Published message to ${topic}`);
}

export async function subscribeToNatsTopic(
	nc: NatsConnection,
	subject: string,
	callback: (msg: Uint8Array) => void
): Promise<() => Promise<void>> {
	if (!nc) {
		console.error("NatsClient:: No connection established.");
		return async () => {};
	}

	const subscription = nc.subscribe(subject);
	const unlisten = async () => {
		await subscription.drain();
	};

	for await (const msg of subscription) {
		callback(msg.data);
		console.log(`NatsClient:: Received message on ${subject}`);
	}

	return unlisten;
}
